export const FETCH_CARTDATA_REQUEST='cart/fetch/request';
export const FETCH_CARTDATA_SUCCESS='cart/fetch/success';
export const FETCH_CARTDATA_FAILURE='cart/fetch/failure';

export const ADD_TO_CART_REQUEST='add/cart/request';
export const ADD_TO_CART_SUCCESS='add/cart/success';
export const ADD_TO_CART_FAILURE='add/cart/failure';

export const UPDATE_CART_REQUEST='update/cart/request';
export const UPDATE_CART_SUCCESS='update/cart/success';
export const UPDATE_CART_FAILURE='update/cart/failure';

export const DELETE_FROM_CART_REQUEST='delete/cart/request';
export const DELETE_FROM_CART_SUCCESS='delete/cart/success';
export const DELETE_FROM_CART_FAILURE='delete/cart/failure';